import {closeSession} from './general';

class API_Sessions {
    private forms = {};

    setFormSession = (formName: string, form, cols) => {
        this.forms = {
            ...this.forms,
            [formName]: {
                form: {...form, formName},
                cols
            }
        };
    };

    getFormByKey = (key: string) => {
        return this.forms[key];
    };

    removeFormByKey = (key: string) => {
        delete this.forms[key];
    };

    clearAllForms = async () => {
        try {
            const sessions = Object.keys(this.forms).map(formName => {
                const data = this.forms[formName];
                return {
                    Session: data.form.Session,
                    formName
                };
            });

            for (const sessionData of sessions) {
                await closeSession(sessionData.Session, sessionData.formName);
            }

            this.forms = {};
        } catch (e) {
            console.error(e);
        }
    };
}

export const onboardingSessions = new API_Sessions();
